import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AdjustmentOrderState,
  AdjustmentOrderPayload,
} from "src/types/adjustmentOrder.types";

const initialState: AdjustmentOrderState = {
  list: { loading: false, data: null, error: null },
  create: { loading: false, data: null, error: null },
};

const adjustmentOrderSlice = createSlice({
  name: "adjustmentOrder",
  initialState,
  reducers: {
    // 📋 List AdjustmentOrder Orders
    getAdjustmentOrderListRequest: (
      state,
      _action: PayloadAction<{
        page?: number;
        limit?: number;
      }>
    ) => {
      state.list.loading = true;
      state.list.error = null;
    },
    getAdjustmentOrderListSuccess: (state, action: PayloadAction<any>) => {
      state.list.loading = false;
      state.list.data = action.payload;
    },
    getAdjustmentOrderListError: (state, action: PayloadAction<string>) => {
      state.list.loading = false;
      state.list.error = action.payload;
    },
    resetAdjustmentOrderList: (state) => {
      state.list = { loading: false, data: null, error: null };
    },

    // 🧾 Create AdjustmentOrder Order
    createAdjustmentOrderRequest: (
      state,
      _action: PayloadAction<AdjustmentOrderPayload>
    ) => {
      state.create.loading = true;
      state.create.error = null;
    },
    createAdjustmentOrderSuccess: (state, action: PayloadAction<any>) => {
      state.create.loading = false;
      state.create.data = action.payload;
    },
    createAdjustmentOrderError: (state, action: PayloadAction<string>) => {
      state.create.loading = false;
      state.create.error = action.payload;
    },
    resetCreateAdjustmentOrder: (state) => {
      state.create = { loading: false, data: null, error: null };
    },
  },
});

export const {
  getAdjustmentOrderListRequest,
  getAdjustmentOrderListSuccess,
  getAdjustmentOrderListError,
  resetAdjustmentOrderList,
  createAdjustmentOrderRequest,
  createAdjustmentOrderSuccess,
  createAdjustmentOrderError,
  resetCreateAdjustmentOrder,
} = adjustmentOrderSlice.actions;

export default adjustmentOrderSlice.reducer;
